export default __webpack_public_path__ + "static/media/shirtly-logo-small.2c2a8657.png";